export var BrowserType = Object.freeze({
  NONE: 0,
  FIREFOX: 1,
  SAFARI: 2,
  IE: 3,
  EDGE: 4,
  CHROME: 5,
  EDGECHROMIUM: 6,
  BLINK: 7
})

export const detectBrowser = () => {
  if (isFirefox) return BrowserType.FIREFOX
  // else if (isSafari) return BrowserType.SAFARI;
  else if (isIE) return BrowserType.IE
  else if (isEdge) return BrowserType.EDGE
  else if (isChrome) return BrowserType.CHROME
  else if (isEdgeChromium) return BrowserType.EDGECHROMIUM
  else if (isBlink) return BrowserType.BLINK
  else return BrowserType.NONE
}

// Firefox 1.0+
var isFirefox = typeof InstallTrigger !== 'undefined'

// Safari 3.0+ "[object HTMLElementConstructor]"
// var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// Internet Explorer 6-11
var isIE = /* @cc_on!@ */ false || !!document.documentMode

// Edge 20+
var isEdge = !isIE && !!window.StyleMedia

// Chrome 1 - 79
var isChrome =
  !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

// Edge (based on chromium) detection
var isEdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') !== -1

// Blink engine detection
var isBlink = isChrome && !!window.CSS
